<template>
  <div class="tag-component">
    <span v-for="(tag, index) in tags" :key="index">{{ tag }}</span>
  </div>
</template>
<script>
export default {
  props: {
    tags: {
      type: Array,
      default: () => []
    }
  }
};
</script>
<style lang="scss">
.tag-component {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  gap: 8px;
  span {
    color: #ab85e5;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px; /* 166.667% */
    border-radius: 4px;
    padding: 2px 6px;
    background: rgba(171, 133, 229, 0.2);
    display: flex;
  }
}
</style>
